export const CLOSED_DAY = 'Closed';
export const DAYS_OF_THE_WEEK = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];
export const FAUX_MIDNIGHT = 1439;
export const NOON = 720;



// WEBPACK FOOTER //
// ./public/js/components/HoursOfOperation/constants.js